import { LoadingLifecycle } from '@ms/yammer-data-support';

export interface RealtimeClient {
  readonly status: RealtimeClientStatus;
  readonly uriLifecycle: LoadingLifecycle<string>;
}

export enum RealtimeClientStatus {
  Connected = 'Connected',
  Interrupted = 'Interrupted',
  Connecting = 'Connecting',
  Disconnected = 'Disconnected',
}
